import { createActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

export const types = {
  SHOW_CHAT_STAGE_MODAL: 'SHOW_CHAT_STAGE_MODAL',
  HIDE_CHAT_STAGE_MODAL: 'HIDE_CHAT_STAGE_MODAL',
  UPDATE_STAGE_AND_SHOW_CHAT_STAGE_MODAL:
    'UPDATE_STAGE_AND_SHOW_CHAT_STAGE_MODAL',
};

export const {
  showChatStageModal,
  hideChatStageModal,
  updateStageAndShowChatStageModal,
} = createActions(
  {
    [types.UPDATE_STAGE_AND_SHOW_CHAT_STAGE_MODAL]: (stage) => ({
      stage,
    }),
  },
  types.SHOW_CHAT_STAGE_MODAL,
  types.HIDE_CHAT_STAGE_MODAL
);

const INIT_STATE = {
  isVisible: false,
};

const reducer = handleActions(
  {
    [types.SHOW_CHAT_STAGE_MODAL]: () => ({
      isVisible: true,
    }),
    [types.HIDE_CHAT_STAGE_MODAL]: () => ({
      isVisible: false,
    }),
  },
  INIT_STATE
);

export default reducer;
export const getChatModal = (state) => state.chat.chatModal;
export const getChatModalIsVisible = createSelector(
  getChatModal,
  (chatModal) => chatModal.isVisible
);



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/chatModal.js